var map = {
	"./ID.webp": 777,
	"./INDO.webp": 778,
	"./MY.webp": 779,
	"./TH.webp": 780,
	"./VN.webp": 781,
	"./malaysia.webp": 782
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 394;
module.exports = webpackAsyncContext;